import {
  AnyTyreIdentifier,
  ITyreIdentifierField,
  ITyre,
  ITyreInfoBox,
} from '@wyz/types';

export function getBrandLogoUrl(brandName: string): string {
  return `/common/logos/brand-logo/color/${brandName.toLowerCase()}.png`;
}

export function getHomologationLogoUrl(brand: string): string {
  return `/wyz-data-prod/pictures/marking/${brand}.png`;
}

export function getHomologationBrandImage(
  homologations: Array<{ brand: string; image: boolean }> | undefined,
): string | undefined {
  return homologations?.length === 1 && homologations[0].image
    ? homologations[0].brand
    : undefined;
}

export function getTyreIdentifiers(
  identifiers: {
    cai: string;
    constructorReference?: string;
    alternativeReference?: string;
  },
  identifierTypes: Array<ITyreIdentifierField> | undefined,
): AnyTyreIdentifier {
  return identifierTypes
    ? {
        identifierType: 'ALL',
        cai: identifierTypes.includes('CAI') ? identifiers.cai : undefined,
        constructorReference: identifierTypes.includes('CONSTRUCTOR_REFERENCE')
          ? identifiers.constructorReference
          : undefined,
        alternativeReference: identifierTypes.includes('WYZ_REFERENCE')
          ? identifiers.alternativeReference
          : undefined,
      }
    : {
        identifierType: undefined,
        alternativeReference: undefined,
        constructorReference: undefined,
        cai: undefined,
      };
}

export function mapTyreIntoInfoBox(
  tyre: ITyre,
  identifierTypes: ITyreIdentifierField[] | undefined,
): ITyreInfoBox {
  const dynamicProps = getTyreIdentifiers(
    {
      cai: tyre.supplierCode,
      constructorReference: tyre.constructorReference,
      alternativeReference: tyre.alternativeReference,
    },
    identifierTypes,
  );
  return {
    ean: tyre.ean,
    brand: tyre.brand.name,
    profile: tyre.profile.design1,
    dimension: tyre.dimension.fullSize,
    prodInfo: tyre.prodInfo,
    season: tyre.season.name,
    seasonPmsf: tyre.season.pmsf,
    vehicleType: tyre.vehicleType.name,
    homologations: tyre.homologations,
    ...dynamicProps,
  };
}

export const DEFAULT_TIRE_BRAND_LOGO = '/img/default-brand-logo.png';
export const DEFAULT_TIRE_BRAND_WIDTH = {
  sm: 82,
  lg: 120,
} as const;
